export const ActivityLogMock = [
  {
    id: 'f13dbcd5-3617-4b57-a828-191a0962b776',
    deviceName: '#3 - EPE200 SSR',
    deviceId: '8f9bf744-3c72-4107-a1e9-ba62f657705d',
    value: 'modulationOff',
    createdDate: '2024-06-25T05:26:01.280Z',
    updateDate: '2024-06-25T05:26:12.787Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'b933ba1b-2f5f-47d5-8ec2-e949b294e109',
    indicatorName: 'modulation_off',
    engineReason: '(2), 499.1 CFM, 92.2 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: '443f1d42-cc64-44d9-a015-5798afcf7270',
    deviceName: '#3 - EPE200 SSR',
    deviceId: '8f9bf744-3c72-4107-a1e9-ba62f657705d',
    value: '[85,95]',
    createdDate: '2024-06-25T05:26:01.165Z',
    updateDate: '2024-06-25T05:26:07.967Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: '2ef96e53-ac58-408b-a8af-b97d9843f621',
    indicatorName: 'Load and Unload pressures',
    engineReason: '(2), 499.1 CFM, 92.2 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'a839854f-8936-471d-9d41-bfdc0d36c68d',
    deviceName: '#2 - TS20',
    deviceId: '528',
    value: 'modulationOff',
    createdDate: '2024-06-25T05:26:01.075Z',
    updateDate: '2024-06-25T05:26:28.637Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'aa01253a-b03c-4989-8ad1-0b7daa207538',
    indicatorName: 'modulate_off',
    engineReason: '(2), 499.1 CFM, 92.2 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: '7e543dba-85bb-46cc-a42d-96f39cf5bf5d',
    deviceName: '#2 - TS20',
    deviceId: '528',
    value: '[88,105]',
    createdDate: '2024-06-25T05:26:00.941Z',
    updateDate: '2024-06-25T05:26:21.078Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: '26454ad3-d23c-4d94-aa3f-ad8634c15fb5',
    indicatorName: 'Unload and Load pressures',
    engineReason: '(2), 499.1 CFM, 92.2 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'e81ef802-27a9-4bb7-9742-fde2e681c73e',
    deviceName: '#1 - V200TS',
    deviceId: '527',
    value: '[91,103,94]',
    createdDate: '2024-06-25T05:26:00.817Z',
    updateDate: '2024-06-25T05:26:29.097Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'c295f6e4-5f22-482a-9e60-b4d713ccc3e6',
    indicatorName: 'load_unload_target_setpoints',
    engineReason: '(2), 499.1 CFM, 92.2 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'aa5c36d5-6702-45c6-ad62-8463b269f0e8',
    deviceName: '#3 - EPE200 SSR',
    deviceId: '8f9bf744-3c72-4107-a1e9-ba62f657705d',
    value: 'modulationOff',
    createdDate: '2024-06-25T05:24:58.951Z',
    updateDate: '2024-06-25T05:25:11.840Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'b933ba1b-2f5f-47d5-8ec2-e949b294e109',
    indicatorName: 'modulation_off',
    engineReason: '(2), 482.8 CFM, 92.0 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'cdba4a51-8fc7-4e9d-8f83-0f416ab6dc7b',
    deviceName: '#3 - EPE200 SSR',
    deviceId: '8f9bf744-3c72-4107-a1e9-ba62f657705d',
    value: '[85,95]',
    createdDate: '2024-06-25T05:24:58.857Z',
    updateDate: '2024-06-25T05:25:06.773Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: '2ef96e53-ac58-408b-a8af-b97d9843f621',
    indicatorName: 'Load and Unload pressures',
    engineReason: '(2), 482.8 CFM, 92.0 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: '6daa10c5-3614-4ce4-98cd-21d05d5792c3',
    deviceName: '#2 - TS20',
    deviceId: '528',
    value: 'modulationOff',
    createdDate: '2024-06-25T05:24:58.768Z',
    updateDate: '2024-06-25T05:25:29.616Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'aa01253a-b03c-4989-8ad1-0b7daa207538',
    indicatorName: 'modulate_off',
    engineReason: '(2), 482.8 CFM, 92.0 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: '5ff413c8-491e-4b3e-8727-09be65e2ceff',
    deviceName: '#2 - TS20',
    deviceId: '528',
    value: '[88,105]',
    createdDate: '2024-06-25T05:24:58.663Z',
    updateDate: '2024-06-25T05:25:21.019Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: '26454ad3-d23c-4d94-aa3f-ad8634c15fb5',
    indicatorName: 'Unload and Load pressures',
    engineReason: '(2), 482.8 CFM, 92.0 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: '6d2a8b8e-7643-4eb1-b856-56fe41e595dc',
    deviceName: '#1 - V200TS',
    deviceId: '527',
    value: '[91,103,94]',
    createdDate: '2024-06-25T05:24:58.576Z',
    updateDate: '2024-06-25T05:25:23.976Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'c295f6e4-5f22-482a-9e60-b4d713ccc3e6',
    indicatorName: 'load_unload_target_setpoints',
    engineReason: '(2), 482.8 CFM, 92.0 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'b9ef6776-57ae-492d-aab6-1dbd09a1c312',
    deviceName: '#3 - EPE200 SSR',
    deviceId: '8f9bf744-3c72-4107-a1e9-ba62f657705d',
    value: 'modulationOff',
    createdDate: '2024-06-25T05:23:55.340Z',
    updateDate: '2024-06-25T05:24:12.840Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'b933ba1b-2f5f-47d5-8ec2-e949b294e109',
    indicatorName: 'modulation_off',
    engineReason: '(2), 570.2 CFM, 91.7 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: '4b80c12f-eccf-4925-b429-d00fea129c6b',
    deviceName: '#3 - EPE200 SSR',
    deviceId: '8f9bf744-3c72-4107-a1e9-ba62f657705d',
    value: '[85,95]',
    createdDate: '2024-06-25T05:23:55.203Z',
    updateDate: '2024-06-25T05:24:07.983Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: '2ef96e53-ac58-408b-a8af-b97d9843f621',
    indicatorName: 'Load and Unload pressures',
    engineReason: '(2), 570.2 CFM, 91.7 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'a4b23d27-0f9b-41fb-995b-ca562dad3648',
    deviceName: '#2 - TS20',
    deviceId: '528',
    value: 'modulationOff',
    createdDate: '2024-06-25T05:23:55.097Z',
    updateDate: '2024-06-25T05:24:24.948Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'aa01253a-b03c-4989-8ad1-0b7daa207538',
    indicatorName: 'modulate_off',
    engineReason: '(2), 570.2 CFM, 91.7 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: '59356b6f-d215-4693-a464-5c13d6c6d157',
    deviceName: '#2 - TS20',
    deviceId: '528',
    value: '[88,105]',
    createdDate: '2024-06-25T05:23:54.955Z',
    updateDate: '2024-06-25T05:24:15.884Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: '26454ad3-d23c-4d94-aa3f-ad8634c15fb5',
    indicatorName: 'Unload and Load pressures',
    engineReason: '(2), 570.2 CFM, 91.7 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: '062d5408-7be3-479e-b6f9-ebabcf2eb5ea',
    deviceName: '#1 - V200TS',
    deviceId: '527',
    value: '[91,103,94]',
    createdDate: '2024-06-25T05:23:54.807Z',
    updateDate: '2024-06-25T05:24:24.677Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'c295f6e4-5f22-482a-9e60-b4d713ccc3e6',
    indicatorName: 'load_unload_target_setpoints',
    engineReason: '(2), 570.2 CFM, 91.7 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'a223c901-b3ea-4185-8642-2331129ca875',
    deviceName: '#3 - EPE200 SSR',
    deviceId: '8f9bf744-3c72-4107-a1e9-ba62f657705d',
    value: 'modulationOff',
    createdDate: '2024-06-25T05:22:50.010Z',
    updateDate: '2024-06-25T05:22:56.570Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'b933ba1b-2f5f-47d5-8ec2-e949b294e109',
    indicatorName: 'modulation_off',
    engineReason: '(2), 524.9 CFM, 91.7 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: '34f68093-dcd9-473f-8526-c121ee19c4d7',
    deviceName: '#3 - EPE200 SSR',
    deviceId: '8f9bf744-3c72-4107-a1e9-ba62f657705d',
    value: '[85,95]',
    createdDate: '2024-06-25T05:22:49.905Z',
    updateDate: '2024-06-25T05:22:57.034Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: '2ef96e53-ac58-408b-a8af-b97d9843f621',
    indicatorName: 'Load and Unload pressures',
    engineReason: '(2), 524.9 CFM, 91.7 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'ec452eba-a368-43e5-bd3a-5224d33f1d56',
    deviceName: '#2 - TS20',
    deviceId: '528',
    value: 'modulationOff',
    createdDate: '2024-06-25T05:22:49.802Z',
    updateDate: '2024-06-25T05:23:19.183Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'aa01253a-b03c-4989-8ad1-0b7daa207538',
    indicatorName: 'modulate_off',
    engineReason: '(2), 524.9 CFM, 91.7 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: '0b39db2e-a51f-4ef3-939b-c13d6daadc1a',
    deviceName: '#2 - TS20',
    deviceId: '528',
    value: '[88,105]',
    createdDate: '2024-06-25T05:22:49.704Z',
    updateDate: '2024-06-25T05:23:11.005Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: '26454ad3-d23c-4d94-aa3f-ad8634c15fb5',
    indicatorName: 'Unload and Load pressures',
    engineReason: '(2), 524.9 CFM, 91.7 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'b6aea82e-9849-49fc-8450-7b85bf5a925e',
    deviceName: '#1 - V200TS',
    deviceId: '527',
    value: '[91,103,94]',
    createdDate: '2024-06-25T05:22:49.554Z',
    updateDate: '2024-06-25T05:23:19.281Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'c295f6e4-5f22-482a-9e60-b4d713ccc3e6',
    indicatorName: 'load_unload_target_setpoints',
    engineReason: '(2), 524.9 CFM, 91.7 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'c51aca87-28e3-40af-8e52-2c0fe1b34d16',
    deviceName: '#3 - EPE200 SSR',
    deviceId: '8f9bf744-3c72-4107-a1e9-ba62f657705d',
    value: 'modulationOff',
    createdDate: '2024-06-25T05:21:48.184Z',
    updateDate: '2024-06-25T05:21:56.666Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'b933ba1b-2f5f-47d5-8ec2-e949b294e109',
    indicatorName: 'modulation_off',
    engineReason: '(2), 499.1 CFM, 91.8 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'c80e2e08-6b51-4847-a9f1-eabf3985c801',
    deviceName: '#3 - EPE200 SSR',
    deviceId: '8f9bf744-3c72-4107-a1e9-ba62f657705d',
    value: '[85,95]',
    createdDate: '2024-06-25T05:21:48.071Z',
    updateDate: '2024-06-25T05:21:57.426Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: '2ef96e53-ac58-408b-a8af-b97d9843f621',
    indicatorName: 'Load and Unload pressures',
    engineReason: '(2), 499.1 CFM, 91.8 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'c3778c98-4a8f-48af-881d-e80f61d5388a',
    deviceName: '#2 - TS20',
    deviceId: '528',
    value: 'modulationOff',
    createdDate: '2024-06-25T05:21:47.943Z',
    updateDate: '2024-06-25T05:22:15.575Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'aa01253a-b03c-4989-8ad1-0b7daa207538',
    indicatorName: 'modulate_off',
    engineReason: '(2), 499.1 CFM, 91.8 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: '3e5b7344-d1f6-4279-bd04-fbb84ceb6c02',
    deviceName: '#2 - TS20',
    deviceId: '528',
    value: '[88,105]',
    createdDate: '2024-06-25T05:21:47.761Z',
    updateDate: '2024-06-25T05:22:06.868Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: '26454ad3-d23c-4d94-aa3f-ad8634c15fb5',
    indicatorName: 'Unload and Load pressures',
    engineReason: '(2), 499.1 CFM, 91.8 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
  {
    id: 'a920d893-c4ca-4339-ac0b-cb18a40f4af8',
    deviceName: '#1 - V200TS',
    deviceId: '527',
    value: '[91,103,94]',
    createdDate: '2024-06-25T05:21:47.430Z',
    updateDate: '2024-06-25T05:22:14.587Z',
    status: 'commandReceivedAndUpdated',
    userName: 'proactive_engine_prod@ecoplant.co',
    indicatorId: 'c295f6e4-5f22-482a-9e60-b4d713ccc3e6',
    indicatorName: 'load_unload_target_setpoints',
    engineReason: '(2), 499.1 CFM, 91.8 PSI',
    failureReason: null,
    displayValue: null,
    delayInSeconds: null,
    source: 'cloud',
    version: 'v1.5',
  },
];
